export default (state = {}) => {
  return {
    ...state,
    loginLoading: true,
  };
};
